import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const LotManagementDialogTourConfig: AgTechTourConfig = {
    id: 'lot-management-dialog-tour',
    name: 'Lot Management Tour',
    steps: [
        {
            targetId: 'lot-management-metrics',
            title: 'Lot Metrics',
            description: 'A live snapshot of your lot inventory: total lots entered, how many have sold, and how many have been invoiced.',
            position: 'bottom',
        },
        {
            targetId: 'lot-management-import-btn',
            title: 'Import Lots',
            description: 'Import lots in bulk from a spreadsheet. Use this to quickly populate a sale with many lots at once.',
            position: 'bottom',
        },
        {
            targetId: 'lot-management-view-lots-tab',
            title: 'View Lots',
            description: 'Browse all lots in the sale with their details, current status, and purchase information.',
            onActivate: () => document.getElementById('lot-management-view-lots-tab')?.click(),
        },
        {
            targetId: 'lot-management-update-lots-tab',
            title: 'Update Lots',
            description: 'Make bulk edits to lot details — descriptions, categories, and sale order — directly in the grid without opening individual lot forms.',
            onActivate: () => document.getElementById('lot-management-update-lots-tab')?.click(),
        },
        {
            targetId: 'lot-management-sell-lots-tab',
            title: 'Sell Lots',
            description: 'Assign bidders and purchase prices to lots directly in this grid as the auction progresses.',
            onActivate: () => document.getElementById('lot-management-sell-lots-tab')?.click(),
        },
    ]
}
